import createBrowserHistory from 'history/lib/createBrowserHistory';

const history = createBrowserHistory();

export default history;



// WEBPACK FOOTER //
// ./src/js/helpers/history.js